const META_STATUS_TYPE = {
    ACTIVE: 'ACTIVE', // Active campaign
    PAUSED: 'PAUSED' // Paused campaign
}

const META_OBJECTIVES_TYPE = {
    OUTCOME_AWARENESS: "OUTCOME_AWARENESS", // Increase brand awareness or reach
    OUTCOME_TRAFFIC: "OUTCOME_TRAFFIC", // Send people to a destination like a website or app
    OUTCOME_ENGAGEMENT: "OUTCOME_ENGAGEMENT", // Get more engagement on your content (likes, comments, shares)
    OUTCOME_LEADS: "OUTCOME_LEADS", // Collect leads through forms, messages, or calls
    OUTCOME_APP_PROMOTION: "OUTCOME_APP_PROMOTION", //	Promote app installs and engagement
    OUTCOME_SALES: "OUTCOME_SALES", // Drive sales or conversions (e.g., website purchases, catalog sales)
    OUTCOME_LOCAL_AWARENESS: "OUTCOME_LOCAL_AWARENESS", // Reach people near your business
    OUTCOME_VIDEO_VIEWS: "OUTCOME_VIDEO_VIEWS", // Get more views on your video content
    OUTCOME_REACH: "OUTCOME_REACH", //Maximize the number of people who see your ads
}

const META_BUYING_TYPE = {
    AUCTION: 'AUCTION', // Allow Meta to set your bid
    FIXED: 'FIXED' // Use a fixed bid
}

const META_BID_STRATEGY = {
    LOWEST_COST_WITHOUT_CAP: 'LOWEST_COST_WITHOUT_CAP', // Let Meta get the most results for the lowest cost (no bid cap)
    LOWEST_COST_WITH_BID_CAP: 'LOWEST_COST_WITH_BID_CAP', // Set a maximum bid you're willing to pay per result
    COST_CAP: 'COST_CAP', // Control average cost per result over time (cost control + volume balance)
    TARGET_COST: 'TARGET_COST' // Try to maintain a stable average cost (older campaigns)
}

const META_SPLIT_TEST_VARIABLE_TYPE = {
    AGE: "AGE",	// Test different age ranges of your target audience
    GENDER: "GENDER",	// Test targeting by gender (e.g., male vs female)
    PLACEMENT: "PLACEMENT",	// Test ad placements (e.g., Facebook Feed vs Instagram Stories)
    OPTIMIZATION_GOAL: "OPTIMIZATION_GOAL", //	Test different optimization goals (e.g., leads vs link clicks)
    CREATIVE: "CREATIVE", //	Test different ad creatives (images, videos, text)
    DELIVERY_OPTIMIZATION: "DELIVERY_OPTIMIZATION",	// Test delivery settings for better reach or engagement
    AUDIENCE_SEGMENT: "AUDIENCE_SEGMENT", //	Test different audience segments (e.g., lookalike vs custom audience)
    BIDDING_STRATEGY: "BIDDING_STRATEGY" //	Test different bidding strategies (e.g., lowest cost vs cost cap)
}

const META_BILLING_EVENT_TYPE = {
    IMPRESSIONS: "IMPRESSIONS", //	You are billed when your ad is shown (impression-based billing).
    CLICKS: "CLICKS", //	You are billed when someone clicks your ad (link clicks or engagements).
    LINK_CLICKS: "LINK_CLICKS", //	You are billed for link clicks specifically (to a website or app).
    APP_INSTALLS: "APP_INSTALLS", //	Billed when someone installs your app.
    VIDEO_VIEWS: "VIDEO_VIEWS", //	Billed based on video views.
    REACH: "REACH", //	Billed based on the number of unique users reached.
    THRUPLAY: "THRUPLAY", //	Billed when someone watches at least 15 seconds of your video.
    NONE: "NONE", //	No billing event; used only in specific advanced use cases.
    IMPRESSIONS_STANDARD: "IMPRESSIONS_STANDARD", //	Billed per standard impression (used rarely).
}

const META_OPTIMIZATION_GOAL_TYPE = {
    APP_INSTALLS: "APP_INSTALLS", // Optimize for app installs.
    LEAD_GENERATION: "LEAD_GENERATION", // Optimize for leads (via lead forms, etc.).
    CONVERSIONS: "CONVERSIONS", // Optimize for conversions (e.g., purchases, sign-ups).
    AD_RECALL_LIFT: "AD_RECALL_LIFT", // Optimize to increase ad recall.
    CLICKS: "CLICKS", // Optimize for clicks (deprecated, use LINK_CLICKS).
    ENGAGED_USERS: "ENGAGED_USERS", // Optimize for user engagement (interactions with content).
    EVENT_RESPONSES: "EVENT_RESPONSES", // Optimize for event responses.
    IMPRESSIONS: "IMPRESSIONS", // Optimize to get the most impressions.
    LINK_CLICKS: "LINK_CLICKS", // Optimize for link clicks (to websites or apps).
    OFFSITE_CONVERSIONS: "OFFSITE_CONVERSIONS", // Optimize for conversions outside Facebook, like website sales.
    PAGE_LIKES: "PAGE_LIKES", // Optimize for page likes.
    POST_ENGAGEMENT: "POST_ENGAGEMENT", // Optimize for post engagement (likes, shares, comments).
    QUALITY_CALL: "QUALITY_CALL", // Optimize for high-quality calls (for call ads).
    REACH: "REACH", // Optimize for maximum reach (unique impressions).
    LANDING_PAGE_VIEWS: "LANDING_PAGE_VIEWS", // Optimize for landing page views (clicks + page load).
    VALUE: "VALUE", // Optimize for highest conversion value (ROAS).
    THRUPLAY: "THRUPLAY", // Optimize for video views of at least 15 seconds.
    DERIVED_EVENTS: "DERIVED_EVENTS", // Optimize for derived conversion events (custom logic).
    MESSAGING_PURCHASE_CONVERSION: "MESSAGING_PURCHASE_CONVERSION", // Optimize for purchases through messaging apps (e.g., WhatsApp).
    REPLIES: "REPLIES", // Optimize for message replies.
    OMNI_PURCHASE: "OMNI_PURCHASE", // Optimize for cross-platform purchases (Meta ecosystem).
    PRODUCT_CATALOG_SALES: "PRODUCT_CATALOG_SALES", // Optimize for catalog sales (Dynamic Ads).
};

const META_AD_TYPE = {
    BOOK_TRAVEL: "BOOK_TRAVEL",              // Book travel-related services.
    BUY_NOW: "BUY_NOW",                      // Prompt user to purchase immediately.
    CALL_NOW: "CALL_NOW",                    // Tap to call a number.
    CONTACT_US: "CONTACT_US",                // Link to contact page or opens Messenger.
    DONATE_NOW: "DONATE_NOW",                // Encourage donations (non-profits).
    DOWNLOAD: "DOWNLOAD",                    // Download file, app, or resource.
    GET_DIRECTIONS: "GET_DIRECTIONS",        // Open directions to a location.
    GET_OFFER: "GET_OFFER",                  // Claim an offer (discount, coupon).
    GET_OFFER_VIEW: "GET_OFFER_VIEW",        // View offer details.
    GET_QUOTE: "GET_QUOTE",                  // Request a quote for service/product.
    INSTALL_APP: "INSTALL_APP",              // Redirect to app store for install.
    INSTALL_MOBILE_APP: "INSTALL_MOBILE_APP",// App install for mobile.
    LEARN_MORE: "LEARN_MORE",                // Redirect for more information.
    LIKE_PAGE: "LIKE_PAGE",                  // Like the Facebook Page.
    LISTEN_MUSIC: "LISTEN_MUSIC",            // Link to music/audio streaming.
    MESSAGE_PAGE: "MESSAGE_PAGE",            // Open Messenger chat with Page.
    OPEN_LINK: "OPEN_LINK",                  // Opens a specific URL.
    ORDER_NOW: "ORDER_NOW",                  // Encourage immediate purchase/order.
    PLAY_GAME: "PLAY_GAME",                  // Redirect to a game app or platform.
    SHOP_NOW: "SHOP_NOW",                    // Visit shop or product catalog.
    SIGN_UP: "SIGN_UP",                      // Signup for service/newsletter.
    SUBSCRIBE: "SUBSCRIBE",                  // Subscribe to updates/services.
    USE_APP: "USE_APP",                      // Opens an app or directs to install.
    USE_MOBILE_APP: "USE_MOBILE_APP",        // Same as above, mobile-specific.
    WATCH_MORE: "WATCH_MORE",                // Play video or visit to watch.
    WHATSAPP_MESSAGE: "WHATSAPP_MESSAGE",    // Open WhatsApp chat with business.
    SEND_WHATSAPP_MESSAGE: "SEND_WHATSAPP_MESSAGE", // Same as above (newer format).
    VISIT_GROUP: "VISIT_GROUP",              // Redirect to Facebook Group.
    SEE_MENU: "SEE_MENU",                    // View restaurant/cafe menu.
    REQUEST_TIME: "REQUEST_TIME"             // Schedule or request appointment.
};

const META_SPECIAL_AD_CATEGORIES = {
    CREDIT: "CREDIT",
    EMPLOYMENT: "EMPLOYMENT",
    HOUSING: "HOUSING",
    POLITICAL: "POLITICAL"
}

const META_GENDERS = {
    MALE: 1,
    FEMALE: 2,
    "NON-BINARY": 3,
}

const META_CUSTOM_EVENT_TYPE = {
    ADD_TO_CART: "ADD_TO_CART",
    PURCHASE: "PURCHASE",
    LEAD: "LEAD",
    COMPLETE_REGISTRATION: "COMPLETE_REGISTRATION",
    SEARCH: "SEARCH",
    VIEW_CONTENT: "VIEW_CONTENT",
    INITIATE_CHECKOUT: "INITIATE_CHECKOUT",
    ADD_PAYMENT_INFO: "ADD_PAYMENT_INFO",
    CONTACT: "CONTACT",
    CUSTOM: "CUSTOM"
};

const META_AD_CONTENT_TYPE = {
    IMAGE_AD: "IMAGE_AD",
    VIDEO_AD: "VIDEO_AD",
    CAROUSEL_AD: "CAROUSEL_AD",
    SLIDESHOW_AD: "SLIDESHOW_AD",
    COLLECTION_AD: "COLLECTION_AD",
    INSTANT_EXPERIENCE: "INSTANT_EXPERIENCE"
}

const BUDGET_STATUS = {
    OPEN: 'OPEN',
    CLOSE: 'CLOSE'
}

const META_CONVERSION_EVENT_TYPE = {
    WEBSITE: "WEBSITE",	// Conversions occur on a website (e.g., purchase, signup on your site).
    WEBSITE_AND_CALLS: "WEBSITE_AND_CALLS", //Conversions occur on a website (e.g., purchase, signup on your site) and on phone calls.
    INSTANT_FORMS: "INSTANT_FORMS",	//Conversions happen directly in Messenger (e.g., leads or purchases via chat).
    MESSENGER: "MESSENGER",	//Actions happen in Messenger (e.g., leads or purchases via chat).
    INSTANT_FORMS_AND_MESSENGER: "INSTANT_FORMS_AND_MESSENGER",	//Conversions happen directly in Messenger (e.g., leads or purchases via chat) and on instant forms.
    INSTAGRAM: "INSTAGRAM",	//Conversion happens directly via Instagram DMs or actions.
    WHATSAPP: "WHATSAPP",	//Conversions happen on WhatsApp conversations.
    CALL: "CALL",	//Phone call-based conversions (requires call tracking setup).
    APP: "APP", //Conversions happen within your mobile app (Android or iOS).
}

const GOOGLE_ADVERTISING_CHANNEL_TYPE = {
    SEARCH: "SEARCH", // Search Network. Includes display bundled, and Search+ campaigns.
    DISPLAY: "DISPLAY", // Google Display Network only.
    SHOPPING: "SHOPPING", // Shopping campaigns serve on the shopping property and on google.com search results.
    HOTEL: "HOTEL", // Hotel Ads campaigns.
    VIDEO: "VIDEO", // Video campaigns.
    MULTI_CHANNEL: "MULTI_CHANNEL", // App Campaigns, and App Campaigns for Engagement, that run across multiple channels.
    LOCAL: "LOCAL", // Local ads campaigns.
    SMART: "SMART", // Smart campaigns.
    PERFORMANCE_MAX: "PERFORMANCE_MAX", // Performance Max campaigns.
    LOCAL_SERVICES: "LOCAL_SERVICES", // Local services campaigns.
    TRAVEL: "TRAVEL", // Travel campaigns.
    DEMAND_GEN: "DEMAND_GEN", // Demand Gen campaigns.
}

const GOOGLE_BUDGET_DELIVERY_METHOD = {
    STANDARD: "STANDARD", // The budget server will throttle serving evenly across the entire time period.
    ACCELERATED: "ACCELERATED", // The budget server will not throttle serving, and ads will serve as fast as possible.
}

const GOOGLE_STATUS = {
    ENABLED: "ENABLED",
    PAUSED: "PAUSED"
}

const LINKEDIN_STATUS = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED'
}

const LINKEDIN_CAMPAIGN_TYPE = {
    TEXT_AD: "TEXT_AD",                         // Legacy right-rail text ad
    SPONSORED_CONTENT: "SPONSORED_CONTENT",     // Boosted post or single image ad in feed
    SPONSORED_INMAIL: "SPONSORED_INMAIL",       // Message ad (sent to inbox)
    SPONSORED_UPDATES: "SPONSORED_UPDATES",     // Boosted post or single image ad in feed
    DYNAMIC: "DYNAMIC",                         // Personalized dynamic ads (e.g., follower ad)
    EVENT_AD: "EVENT_AD",                       // Promotes LinkedIn Events
    CONTENT: "CONTENT",                         // Document-based ads in feed
}

const LINKEDIN_CAMPAIGN_OBJECTIVE = {
    BRAND_AWARENESS: "BRAND_AWARENESS",         // Increase awareness of your brand.
    WEBSITE_VISITS: "WEBSITE_VISITS",           // Drive traffic to your website.
    ENGAGEMENT: "ENGAGEMENT",                   // Increase engagement (likes, comments, shares, etc.).
    VIDEO_VIEWS: "VIDEO_VIEWS",                 // Get people to watch your videos.
    LEAD_GENERATION: "LEAD_GENERATION",         // Collect leads using LinkedIn lead gen forms.
    WEBSITE_CONVERSIONS: "WEBSITE_CONVERSIONS", // Drive valuable actions on your site (e.g., purchases).
    JOB_APPLICANTS: "JOB_APPLICANTS",           // Attract candidates to job postings.
    TALENT_LEADS: "TALENT_LEADS",               // Capture interest from talent prospects (Recruiter users).
}

const LINKEDIN_OPTIMIZATION_TARGET_TYPE = {
    CPA: "CPA", // Cost per action
    CPM: "CPM", // Cost per thousand impressions
    CPV: "CPV", // Cost per view
    CPC: "CPC", // Cost per click
}

export {
    META_STATUS_TYPE, META_OBJECTIVES_TYPE, META_BUYING_TYPE, META_BID_STRATEGY, META_SPLIT_TEST_VARIABLE_TYPE, META_BILLING_EVENT_TYPE, META_OPTIMIZATION_GOAL_TYPE,
    META_AD_TYPE, META_SPECIAL_AD_CATEGORIES, META_GENDERS, META_CUSTOM_EVENT_TYPE, META_AD_CONTENT_TYPE, BUDGET_STATUS, META_CONVERSION_EVENT_TYPE,
    GOOGLE_BUDGET_DELIVERY_METHOD, GOOGLE_ADVERTISING_CHANNEL_TYPE, GOOGLE_STATUS, LINKEDIN_STATUS, LINKEDIN_CAMPAIGN_TYPE, LINKEDIN_CAMPAIGN_OBJECTIVE, LINKEDIN_OPTIMIZATION_TARGET_TYPE
};